import { BaseCustomError, ErrorCode } from './base';

export class NotFoundError extends BaseCustomError {
  public static Workout(id: string) {
    return new NotFoundError('Workout', id);
  }

  public static User(id: string) {
    return new NotFoundError('User', id);
  }

  constructor(resource: string, id: string, errorCode: ErrorCode = ErrorCode.NotFound) {
    super(404, `No ${resource} found with id ${id}`, undefined, errorCode);
  }
}
